import { generateSasUriToken } from "../components/action";
import { getBlobUri } from "./general-config";

function buildBlobFetchUrl(blobPath: string, sasToken: string): string {
  if (blobPath.startsWith("http")) {
    return `${blobPath}${sasToken}`;
  }

  const normalized = blobPath.replace(/^pdfsimpliusers\//, "");
  return `${getBlobUri()}pdfsimpliusers/${normalized}${sasToken}`;
}

export async function fetchBlobFromResultPath(blobPath: string): Promise<Blob> {
  const sasToken = await generateSasUriToken();
  const response = await fetch(buildBlobFetchUrl(blobPath, sasToken));
  if (!response.ok) {
    throw new Error(`Failed to fetch blob result: ${response.statusText}`);
  }
  return response.blob();
}

export async function fetchJsonFromResultPath<T>(blobPath: string): Promise<T> {
  const sasToken = await generateSasUriToken();
  const response = await fetch(buildBlobFetchUrl(blobPath, sasToken));
  if (!response.ok) {
    throw new Error(`Failed to fetch blob result: ${response.statusText}`);
  }
  return response.json() as Promise<T>;
}
